<div class="snow-container" *ngIf="isChristmasMode">
  <div 
    *ngFor="let flake of snowflakes; let i = index"
    class="snowflake"
    [style.left]="flake.left"
    [style.animation-delay]="flake.animationDelay"
    [style.width]="flake.size"
    [style.height]="flake.size"
    [style.opacity]="flake.opacity"
  ></div>
</div>

